import React from 'react';
import AgentTripsView from './agent-trips-view';
import useURLSearchQuery from '../../../hooks/use-url-for-search-query';
import useTripMatchSearch from '../../../hooks/use-trip-match-search';

interface DefaultSearch {
  [key: string]: string | string[];
  order: string;
  sort: string;
  assignedTo: string[];
  status: string[];
  fullText: string;
}

const AgentTripsContainer = ({ agentId }: { agentId?: string }) => {
  const defaultSearch: DefaultSearch = {
    order: 'desc',
    sort: 'createdAt',
    assignedTo: agentId ? [agentId] : [],
    status: [],
    fullText: '',
  };

  const [queryValues, updateURLQuery] = useURLSearchQuery<DefaultSearch>(defaultSearch);
  const {
    tripMatches,
    error,
    hasMore,
    isLoading,
    loadMore,
    totalHits,
    sortBy,
  } = useTripMatchSearch({ ...queryValues, assignedTo: agentId ? [agentId] : [] });

  const onChangeFilter = (name: string, v: string | string[]) => {
    updateURLQuery({ [name]: v });
  };

  const formattedTMCount = new Intl.NumberFormat('en-US').format(totalHits);

  return (
    <AgentTripsView
      error={error}
      hasMoreItems={hasMore}
      isLoading={isLoading}
      items={tripMatches}
      loadMore={loadMore}
      onChangeFilter={onChangeFilter}
      searchValue={queryValues.fullText}
      selectedStatusChips={queryValues.status}
      sortBy={sortBy[0]}
      totalHits={formattedTMCount}
    />
  );
};

export default AgentTripsContainer;
